import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { UserApiItem } from 'typings/api';
import { OrNull } from 'typings/shared';
import { UserState } from 'typings/state';

const getResourceState = (state: RootState): UserState => state.user;

const selectIsConnected = createSelector(
    getResourceState,
    (authState: UserState): boolean => authState.connectedUser !== null,
);

export const selectConnectedUser = createSelector(
    getResourceState,
    (authState: UserState): OrNull<UserApiItem> => authState.connectedUser,
);

const selectors = {
    ...createResourceListSelectors(getResourceState),
    selectIsConnected,
    selectConnectedUser,
};

export default selectors;
